module.exports = __webpack_public_path__ + "static/media/polyhouse_vs_open_field_farming_img.153b8470.png";